import { CheeseIcon } from './CheeseIcon';

/**
 * author: Thomas de Saint-Exupéry
 * id 618E3DC0-F776-4CFF-BE9F-D6A23D580F5B
 * name cheese
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cheese.svg
 * tags
 * - Food / Drink 
 */
export const SwissCheeseIcon = CheeseIcon;
export default SwissCheeseIcon